<div class="radio-group-container">
  <label class="radio-group-label">{{ label }}</label>
  <div class="radio-group-buttons-container">
    <dx-radio-group [items]="items" [value]="value" layout="horizontal" (onValueChanged)="onValueChanged($event.value)">
    </dx-radio-group>
  </div>
</div>
